<template>
  <a
    class="pp-link-button"
    @click.prevent="state.visible = true"
  >{{ $t('redeem-key') }}</a>
  <ElDialog
    v-model="state.visible"
    :title="$t('redeem-to-use')"
    :width="640"
    append-to-body
    @close="() => {state.code = ''; state.message = ''}"
  >
    <ElInput
      v-model.trim="state.code"
      :disabled="state.loading"
      :placeholder="$t('please-input-redeem')"
      clearable
      @keyup.enter="handleKeyupEnter"
    />
    <div
      v-if="state.message"
      class="input-valid-message"
      title="state.message"
    >
      {{ state.message }}
    </div>
    <template #footer>
      <ElButton
        style="color: #000"
        text
        @click="state.visible = false"
      >
        {{ $t('cancel') }}
      </ElButton>
      <ElButton
        :disabled="!state.code"
        :loading="state.loading"
        style="min-width: 120px"
        type="primary"
        @click="handleKeyupEnter"
      >
        {{ $t('redeem-right-now') }}
      </ElButton>
    </template>
  </ElDialog>
</template>

<script
  lang="ts"
  setup
>
import {
  reactive,
  useI18n,
  watch,
} from '#imports'
import { redeemCDK } from '@/api'
import useMessage from '@/composables/useMessage'
import { useLayout } from '@/store/layout'
import { useUserInfo } from '@/store/userInfo'
import $track from '@/track/webVipPay'

const { t } = useI18n()

const state = reactive<{
  visible: boolean;
  code: string;
  message: string;
  loading: boolean;
}>({
  visible: false,
  code: '',
  message: '',
  loading: false,
})

watch(() => state.visible, (val) => {
  val && (useLayout().sidebarMobileVisible = false)
})

const handleKeyupEnter = async () => {
  // 点击兑换上报
  $track.web_gift_code_pop_click({ button: 'exchange' })
  Object.assign(
    state,
    {
      message: '',
      loading: true,
    },
  )
  const error = (await redeemCDK(state.code)).error.value
  if (error) {
    state.message = error.message
  } else {
    // 兑换成功上报
    $track.web_gift_code_exchange_success({ code: state.code })
    useMessage(t('redeem-success'))
    state.visible = false
    // 更新会员信息
    useUserInfo().refresh()
  }
  state.loading = false
}

watch(() => state.visible, (val) => {
  // 兑换弹框展示上报
  val && $track.web_gift_code_pop_show()
  // 兑换弹框关闭上报
  !val && $track.web_gift_code_pop_click({ button: 'close' })
})

</script>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util.less';

@media screen and (max-width: @mobile-break-width) {
  .pp-link-button {
    justify-content: flex-start;
    margin-left: 14px;
    height: 44px;
  }
}
</style>
